module.exports = __webpack_public_path__ + "img/face_smile.3c59ccf8.svg";